import { ModelClassSign, ControlPlane, Props, state, error, result, revision } from './symbols';
import { ModelControl, ControlFields } from './controlplane';
import { InstanceGuard } from './guards';
export var ModelState;
(function (ModelState) {
    ModelState["Initial"] = "initial";
    ModelState["Ready"] = "ready";
    ModelState["Error"] = "error";
})(ModelState || (ModelState = {}));
export class Model {
    static [ModelClassSign] = true;
    static isModel(instance) {
        return instance instanceof Model;
    }
    static is(instance) {
        return instance instanceof this;
    }
    [ControlPlane];
    [Props];
    constructor(props) {
        if (!InstanceGuard(new.target, props)) {
            throw new Error('Unexpected direct access to Model constructor');
        }
        Object.defineProperty(this, Props, {
            enumerable: false,
            get() { return props; }
        });
        Object.defineProperty(this, ControlPlane, {
            enumerable: false,
            value: new ModelControl()
        });
    }
    get [state]() {
        return this[ControlPlane][ControlFields.State];
    }
    get [result]() {
        return this[ControlPlane][ControlFields.Result];
    }
    get [error]() {
        return this[ControlPlane][ControlFields.Error];
    }
    get [revision]() {
        return this[ControlPlane][ControlFields.Revision];
    }
}
export function isModelClass(target) {
    return target && (ModelClassSign in target);
}
